import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

import {IconButton, Layout, Text, Tooltip} from '@phonectas/unifon-ui-kit';
import NewCopyIcon from 'common/components/icons/NewCopyIcon';
import NewWindowIcon from 'common/components/icons/NewWindowIcon';
import {useCopyToClipboard} from 'common/hooks/useCopyToClipboard';
import {dateByCustomFormat, DATE_FORMATS} from 'utils/date';
import UnifonStarIcon from 'common/components/icons/UnifonStarIcon';
import {StyledTrustpilotButton} from 'common/components/styled';
import {SALES_CRM_URL} from 'common/constants';
import {Account} from 'common/types/store/threeSixtyTypes';

interface CustomerLinksProps {
	data?: Account;
	showTrustpilot: () => void;
	showBytt: () => void;
}
const CustomerLinks: React.FC<CustomerLinksProps> = ({data, showTrustpilot, showBytt}) => {
	const [t] = useTranslation();
	const accDeatails = data?.account_details;
	const [copyToClipboard] = useCopyToClipboard();
	const handleCopy = useCallback((e: React.SyntheticEvent, value: number) => {
		e.stopPropagation();
		copyToClipboard(value);
	}, [copyToClipboard]);

	const handleOpenSalesCrm = useCallback(() => {
		window.open(`${SALES_CRM_URL}${data?.scrm_order_id}`, '_blank');
	}, [data?.scrm_order_id]);

	return (
		<Layout
			direction="column"
			fullWidth
			gap="sm"
			alignItems="baseline"
		>
			<Layout direction="row" fullWidth justifyContent="space-between" nowrap>
				<Layout direction="row" gap="xs" nowrap fullWidth justifyContent="start">
					<Text variant="body" color="textSecondary">
						{
							`${t('Customer last viewed by')}: `
						}
					</Text>
					{
						accDeatails?.last_viewed_by && (
							<Tooltip text={dateByCustomFormat(accDeatails?.last_viewed_at, DATE_FORMATS.DD_MM_YY_HH_mm)}>
								<div style={{cursor: 'pointer'}}>
									<Text variant="body" color="primary">
										{accDeatails?.last_viewed_by || ''}
									</Text>
								</div>
							</Tooltip>
						)
					}
				</Layout>
				<Layout direction="column" nowrap fullWidth>
					<Layout alignItems="center" justifyContent="end" gap="xs" fullWidth>
						<Text variant="body" color="textSecondary">
							{`${t('Customer responsible')}:`}
						</Text>
						<Text variant="body" color="primary">
							{accDeatails?.customer_responsible || ''}
						</Text>
					</Layout>
				</Layout>
			</Layout>
			<Layout direction="row" nowrap gap="md" justifyContent="space-between" fullWidth>
				<Layout gap="xs">
					{
						data?.cdr_account_number && (
							<Layout alignItems="center" gap="none">
								<Text variant="body1" style={{fontSize: '18px'}}>{data?.cdr_account_number}</Text>
								<IconButton onClick={(e) => handleCopy(e, data?.cdr_account_number)} size="xs">
									<NewCopyIcon />
								</IconButton>
							</Layout>
						)
					}
					{/* {
						data?.links?.zendesk && (
							<Layout alignItems="center" gap="none">
								<Text variant="body1" style={{fontSize: '18px'}}>Zendesk</Text>
								<IconButton size="xs" disabled>
									<NewWindowIcon color="#9798A9" />
								</IconButton>
							</Layout>
						)
					} */}
					{/* {
						data?.links?.bedriftsnett && (
							<Layout alignItems="center" gap="none">
								<Text variant="body1" style={{fontSize: '18px'}}>Bedriftsnett</Text>
								<IconButton size="xs" disabled>
									<NewWindowIcon color="#9798A9" />
								</IconButton>
							</Layout>
						)
					} */}
					{/* {
						data?.links?.connect && (
							<Layout alignItems="center" gap="none">
								<Text variant="body1" style={{fontSize: '18px'}}>{t('Connect')}</Text>
								<IconButton size="xs" disabled>
									<NewWindowIcon color="#9798A9" />
								</IconButton>
							</Layout>
						)
					} */}
					{
						data?.scrm_order_id && (
							<Layout alignItems="center" gap="none">
								<Text variant="body1" style={{fontSize: '18px'}}>{t('Sales CRM')}</Text>
								<IconButton size="xs" onClick={handleOpenSalesCrm}>
									<NewWindowIcon color="#9798A9" />
								</IconButton>
							</Layout>
						)
					}
					<Layout alignItems="center" gap="none">
						<Tooltip text={t('Send review request (Trustpilot)')}>
							<StyledTrustpilotButton
								onClick={showTrustpilot}
								icon={<UnifonStarIcon />}
								color="primary"
								variant="action"
							>
								{t('Trustpilot')}
							</StyledTrustpilotButton>
						</Tooltip>
					</Layout>
					<Layout alignItems="center" gap="none">
						{/* <Tooltip text={t('Send review request (Trustpilot)')}> */}
						<StyledTrustpilotButton
							onClick={showBytt}
							color="primary"
							variant="action"
						>
							{t('Bytt.no')}
						</StyledTrustpilotButton>
						{/* </Tooltip> */}
					</Layout>
				</Layout>
			</Layout>
		</Layout>
	);
}

export default CustomerLinks;
